module.exports = __webpack_public_path__ + "static/media/my-info-menu-main-icon.c515d086.svg";